export const plansRoute = '/plans';
export const plansLanguageQueryParam = 'language';

/**
 * Plans path for a non-default supported language. Default and unknown stay on /plans.
 */
export function plansPathForLanguage({
  language,
  supportedLanguages,
}: {
  language: string | null | undefined;
  supportedLanguages: string[];
}): string {
  const defaultLanguage: string | undefined = supportedLanguages[0];

  if (
    !language ||
    language === 'unknown' ||
    language === defaultLanguage ||
    !supportedLanguages.includes(language)
  ) {
    return plansRoute;
  }

  return `/${language}${plansRoute}`;
}
